import {useAsyncEffect} from "ahooks";
import React, {useMemo, useState} from "react";
import {useDispatch} from "react-redux";
import {useLocation, useRoutes} from "react-router-dom";
import {loadLoginUserInfo} from "@/api/user";
import PageLoading from "../../components/loading/PageLoading";
import {userInit} from "@/model/user";
import createRoutes from "../../routes";
import {navigateToLogin} from "@/utils/navigator";
import render from "../../utils/render";
import {getToken, removeTenantId, removeToken} from "@/utils/user";
import '../../common.css';
import {App} from "antd";

function UserApp() {
    const [loading, setLoading] = useState(true);
    let dispatch = useDispatch();
    let location = useLocation()

    useAsyncEffect(async ()=>{
        //初始化用户信息
        if(location.pathname.endsWith("/login") || location.pathname.startsWith("/register") || location.pathname.endsWith("/proxy")) {
           setLoading(false)
           return
        }

        let token = getToken();
        if (!token) {
            navigateToLogin()
        }

        let userInfo = await loadLoginUserInfo();
        if (!userInfo || !userInfo.id) {
            navigateToLogin();
            return;
        }

        if(!userInfo.user){
            removeToken()
            removeTenantId()
            navigateToLogin()
            return
        }

        //初始化用户信息
        dispatch(userInit(userInfo))
        setLoading(false)
    }, [])

    const memoRoutes = useMemo(()=>{
        return createRoutes("app")
    }, [])

    let routes = useRoutes(memoRoutes);
    return  loading ? <PageLoading /> : routes
}

render(<App><UserApp /></App>)
